import React, { useState, useEffect } from 'react';
import { Reward } from '../../types/user';
import { fetchRewards } from '../../services/profileService';

export default function Rewards() {
  const [rewards, setRewards] = useState<Reward[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchRewards()
      .then(setRewards)
      .catch((err: any) => setError(err.message || 'Failed to load rewards'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="profile-loading">Loading rewards…</div>;
  if (error) return <div className="profile-error">{error}</div>;

  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Rewards</h3>
      {rewards.length === 0 ? (
        <p className="profile-empty">No rewards earned yet.</p>
      ) : (
        <table className="profile-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {rewards.map(r => (
              <tr key={r.id}>
                <td>{r.type}</td>
                <td>${r.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                <td>{r.description}</td>
                <td>{new Date(r.date).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
